import React, { useEffect, useState } from "react";
import Logger from "../../services/Logger";
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from "../../services/AuthService";
import { normalizeAuthReturnPath } from "../../config/gameHost";

export function RequireAuth({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const authStatus = await AuthService.isAuthenticated();
                setIsAuthenticated(authStatus);

                if (!authStatus) {
                    const returnTo = normalizeAuthReturnPath(
                        `${location.pathname}${location.search}${location.hash}`,
                    );
                    try {
                        sessionStorage.setItem("puzzleAuthReturnTo", returnTo);
                    } catch {
                        /* ignore */
                    }
                    navigate("/login", { replace: true, state: { from: returnTo } });
                    return;
                }

                const hasAdminRole = await AuthService.hasRole("ROLE_ADMIN");
                if (!hasAdminRole) {
                    setIsAuthenticated(false);
                    navigate("/unauthorized");
                }
            } catch (error) {
                Logger.error("Error checking authentication:", error);
                setIsAuthenticated(false);
                const returnTo = normalizeAuthReturnPath(
                    `${location.pathname}${location.search}${location.hash}`,
                );
                try {
                    sessionStorage.setItem("puzzleAuthReturnTo", returnTo);
                } catch {
                    /* ignore */
                }
                navigate("/login", { replace: true, state: { from: returnTo } });
            } finally {
                setIsLoading(false);
            }
        };

        checkAuth();
    }, [navigate, location.pathname, location.search, location.hash]);

    if (isLoading) {
        return <div>Checking authentication...</div>;
    }

    if (isAuthenticated) {
        return children;
    }

    return <div>Redirecting...</div>;
}
